__turbopack_context__.v({
  "emailLink": "VacancyComponent-module-scss-module__F3Je1G__emailLink",
  "vacancyPage": "VacancyComponent-module-scss-module__F3Je1G__vacancyPage",
  "vacancyPageBlock": "VacancyComponent-module-scss-module__F3Je1G__vacancyPageBlock",
  "vacancyPageBlockDescription": "VacancyComponent-module-scss-module__F3Je1G__vacancyPageBlockDescription",
  "vacancyPageBlockTitle": "VacancyComponent-module-scss-module__F3Je1G__vacancyPageBlockTitle",
  "vacancyPageHead": "VacancyComponent-module-scss-module__F3Je1G__vacancyPageHead",
});
